import { css, Global } from '@emotion/react'

const styles = css`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    width: 100%;
  }
  body {
    height: 100%;
    width: 100%;
    font-family: 'proxima-nova', sans-serif;
  }
  #root {
    height: 100%;
    width: 100%;
  }
`

export default function GlobalStyles() {
  return <Global styles={styles} />
}
